<!-- todo: add buttons to set interval time up and down -->
<template>
  <div v-cloak>
    <div class="setting" style="width:100%;height:100%;padding:1vw">            
      <span class="h2">Select Age</span>
      <div class="flex justify-content-center" style="margin-top:1vw">
        <span class="h2">{{ age }}</span>
        <svg style="width:6vw;height:6vw;margin-left:2vw;vertical-align:middle" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="48" stroke-linecap="round" stroke-linejoin="round" @click="down"><polyline points="112,176 256,336 400,176"/></svg>
        <svg style="width:6vw;height:6vw;vertical-align:middle" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="48" stroke-linecap="round" stroke-linejoin="round" @click="up"><polyline points="112,336 256,176 400,336"/></svg>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'ageSelect',
    emits:["up","down"],
    props: {
      age:Number,
    },
    data() {
      return {
      }
    },
    methods: {
      up() {
        this.$emit("up");
      },
      down() {
        this.$emit("down");
      },
    },
    computed: {

    },
    watch: {  
    },
    mounted() {
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .option {
    font-size:7vw;
    line-height:9vw;
  }

  .setting {
    background-color:rgba(47, 0, 255, 0.161);
  }

  p {
    margin-top:0.5vw;
    margin-bottom:0.5vw;
  }
</style>
